/* eslint-disable max-len */
import { object, SchemaOf, string } from 'yup';

import { ContractCommonData } from '@/graphql/contracts/_generated_/ContractCommonData.fragment';


export type Fields = {
  shipToCustomer?: ContractCommonData['customer'] | undefined | null;
  invoiceToCustomer?: ContractCommonData['customer'] | undefined | null;

};

export const validationSchema: SchemaOf<Fields> = object().shape({
  shipToCustomer: object().shape({
    customerName: string(),
    customerID: string()
  })
    .nullable(),
  invoiceToCustomer: object().shape({
    customerName: string(),
    customerID: string()
  })
    .nullable(),
});
